/**
 * A sign-up's id for the ad platforms: a SHA-256 of the account id, so the
 * account is counted once and no platform sees the id itself. Rejects where
 * there is no Web Crypto (an insecure page).
 */
export async function signupId(userId: string): Promise<string> {
    const bytes = new TextEncoder().encode(`jobenvoy-signup:${userId}`);
    const digest = await crypto.subtle.digest("SHA-256", bytes);
    return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join(
        "",
    );
}
